import styled from '@emotion/styled';

export const ImageWrapper = styled.div`
  &.visible {
    visibility: visible;
  }

  &.hidden {
    visibility: hidden;
  }

  & > span {
    overflow: scroll !important;
  }

  &.disabledScrollY {
    & > span {
      overflow-y: hidden !important;
    }
  }
`;
